import React from "react";
import { useParams } from "react-router-dom";
import EcommerceFibraCarbono from "./EcommerceFibraCarbono";
import EcommerceResinaEpoxica from "./EcommerceResinaEpoxica";
import EcommerceFlakes from "./EcommerceFlakes";
import EcommerceKitOmova from "./EcommerceKitOmova";

const EcommerceCategory = ({ slug: slugProp }) => {
  const { slug: slugParam } = useParams();
  const slug = slugProp || slugParam;

  if (slug === "kit-omova") {
    return <EcommerceKitOmova />;
  }
  if (slug === "fibra-carbono") {
    return <EcommerceFibraCarbono />;
  }
  if (slug === "kit-fibra-resina") {
    return <EcommerceKitOmova />;
  }
  if (slug === "kit-fibra-resina-forrar") {
    return <EcommerceKitOmova />;
  }
  if (slug === "kit-fibra-resina-forrar-flakes") {
    return <EcommerceKitOmova />;
  }
  if (slug === "resina-epoxica") {
    return <EcommerceResinaEpoxica />;
  }
  if (slug === "flakes") {
    return <EcommerceFlakes />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4 py-24">
      <h1 className="text-3xl md:text-4xl font-bold text-gray-800">
        Placeholder: {slug}
      </h1>
    </div>
  );
};

export default EcommerceCategory;
